<ng-container>
    <div class="dialog-main">
        <h1 mat-dialog-title
            class="draggable-dialogue-header center-text"
            cdkDrag
            cdkDragRootElement=".cdk-overlay-pane"
            cdkDragHandle>
            Load Constraint from MDS
        </h1>

        <mat-radio-group appearance="outline" [(ngModel)]="mode">
            <mat-radio-button value="once">One Time</mat-radio-button>
            <mat-radio-button value="scheduled">Scheduled</mat-radio-button>
        </mat-radio-group>

        <mat-form-field class="width100 form-field" appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
            <mat-label>Constraint Name</mat-label>
            <input matInput type="text" id="mdsConstraintName" [(ngModel)]="mdsConstraintName" title="Constraint Name" [disabled]="DisableNameEdit">
        </mat-form-field>
        <br />
        <mat-form-field class="width100 form-field" appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
            <mat-label>Community Page</mat-label>
            <input matInput type="text" id="mdsCommunityPage" [(ngModel)]="mdsCommunityPage" title="Community Page">
        </mat-form-field>
        <br />
        <mat-form-field class="width100 form-field" appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
            <mat-label>Attachment Name</mat-label>
            <input matInput type="text" id="mdsAttachmentNameValue" [(ngModel)]="mdsAttachmentName" title="MDS Attachment Name">
        </mat-form-field>
        <br />

        @if(this.mode == 'scheduled') {
        <strong>Cadence</strong>
        <mat-radio-group [(ngModel)]="cadence" appearance="outline" aria-label="Cadence">
            <mat-radio-button value="hourly">Hourly</mat-radio-button>
            <mat-radio-button value="daily">Daily</mat-radio-button>
            @if(cadence == 'daily') {
            at &nbsp;
            <mat-form-field style="width: 150px;">
                <mat-select [(ngModel)]="mdsScheduleTime">
                    <mat-option [value]="1">1 a.m.</mat-option>
                    <mat-option [value]="2">2 a.m.</mat-option>
                    <mat-option [value]="3">3 a.m.</mat-option>
                    <mat-option [value]="4">4 a.m.</mat-option>
                    <mat-option [value]="5">5 a.m.</mat-option>
                    <mat-option [value]="6">6 a.m.</mat-option>
                    <mat-option [value]="7">7 a.m.</mat-option>
                    <mat-option [value]="8">8 a.m.</mat-option>
                    <mat-option [value]="9">9 a.m.</mat-option>
                    <mat-option [value]="10">10 a.m.</mat-option>
                    <mat-option [value]="11">11 a.m.</mat-option>
                    <mat-option [value]="12">12 p.m.</mat-option>
                    <mat-option [value]="13">1 p.m.</mat-option>
                    <mat-option [value]="14">2 p.m.</mat-option>
                    <mat-option [value]="15">3 p.m.</mat-option>
                    <mat-option [value]="16">4 p.m.</mat-option>
                    <mat-option [value]="17">5 p.m.</mat-option>
                    <mat-option [value]="18">6 p.m.</mat-option>
                    <mat-option [value]="19">7 p.m.</mat-option>
                    <mat-option [value]="20">8 p.m.</mat-option>
                    <mat-option [value]="21">9 p.m.</mat-option>
                    <mat-option [value]="22">10 p.m.</mat-option>
                    <mat-option [value]="23">11 p.m.</mat-option>
                    <mat-option [value]="24">12 p.m.</mat-option>
                </mat-select>
            </mat-form-field>
            }
        </mat-radio-group>

        <br />
        <strong>If blank</strong>
        <mat-radio-group [(ngModel)]="ifBlank" appearance="outline" aria-label="If blank">
            <mat-radio-button value="load">Load file</mat-radio-button>
            <mat-radio-button value="notify">Notify as failure</mat-radio-button>
        </mat-radio-group>
        <br /><br />
        <mat-form-field class="form-field width100" appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
            <mat-label>On success notify</mat-label>
            <input matInput type="text" id="onSuccessNotify" [(ngModel)]="onSuccessNotify">
        </mat-form-field>
        <br />
        <mat-form-field class="form-field width100" appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
            <mat-label>On failure notify</mat-label>
            <input matInput type="text" id="onFailureNotify" [(ngModel)]="onFailureNotify">
        </mat-form-field>
        <br />
        }

        <div class="center-button" mat-dialog-actions>
            @if(mode == 'scheduled') {
            <button mat-raised-button color="primary" [disabled]="disableScheduleButton" (click)="ScheduleLoad()">Schedule</button>
            }
            @if(mode == 'once') {
            <button mat-raised-button color="primary" [disabled]="LoadOnceDisabled" (click)="LoadOnce()">Load Now</button>
            }
            <button mat-raised-button color="secondary" mat-dialog-close>Close</button>
        </div>
        <div style="max-height: 200px; overflow-y: auto;">
            {{Status}}
        </div>
    </div>
</ng-container>
